import PropTypes from 'prop-types';
import connect from 'react-redux/es/connect/connect';
import React, { PureComponent } from 'react';
import Button from 'react-bootstrap/es/Button';
import Form from 'react-bootstrap/es/Form';
import FormGroup from 'react-bootstrap/es/FormGroup';
import FormControl from 'react-bootstrap/es/FormControl';
import ControlLabel from 'react-bootstrap/es/ControlLabel';
import HelpBlock from 'react-bootstrap/es/HelpBlock';
import Col from 'react-bootstrap/es/Col';
import { closeModal } from 'redux/modules/modal';
import { updateProfileData } from 'redux/modules/authentication';
import { joinGroup, getAuthedUserProfile } from 'api/users';
import { addAsUser } from 'api/group';
import Processing from 'components/Spinner/Processing';
import { toast } from 'react-toastify';
import './joinGroupModal.css';

class JoinGroupModal extends PureComponent {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
        profileData: PropTypes.object.isRequired,
        isAddGroup: PropTypes.bool
    }

    static defaultProps = {
        isAddGroup: false
    }

    state = {
        isProcessing: false,
        errorMsg: '',
        accessKey: '',
        groupName: ''
    }

    onSubmit = async (e) => {
        e.preventDefault();

        const accessKey = e.target.access_key.value.trim();

        if (!accessKey) {
            return;
        }

        this.setState({
            isProcessing: true,
            errorMsg: ''
        });

        try {
            const { profileData } = this.props;

            if (!profileData.current_group || profileData.available_role.indexOf(1) === -1) {
                await addAsUser(accessKey);
            }
            else {
                let params = { access_code: accessKey };

                await joinGroup(params);

                const { data } = await getAuthedUserProfile();

                this.props.dispatch(updateProfileData(data));
            }

            this.setState({
                isProcessing: false
            });

            toast.success('Successfully joined the group. The next time you login you will be able to choose which group you want to login with.', {
                autoClose: 8000
            });

            this.props.dispatch(closeModal());
        }
        catch (err) {
            let msg;

            switch (err.response.status) {
                case 422:
                    msg = 'You already joined this group.';
                    break;
                case 404:
                    msg = 'Invalid Access Key. (nonexist)';
                    break;
                default:
                    msg = 'Error ! Failed to join group.';
            }

            this.setState({
                isProcessing: false,
                errorMsg: msg
            });
        }
    }

    onDecline = () => {
        this.setState({ errorMsg: '' });

        this.props.dispatch(closeModal());
    }

    render() {
        return (
            <div className='joingroup-modal'>
                <div className='form-container'>
                    <Form
                        horizontal={true}
                        onSubmit={this.onSubmit}>
                        <FormGroup controlId='formHorizontalEmail' className={this.state.errorMsg ? 'has-error' : ''}>
                            <Col componentClass={ControlLabel} sm={5}>
                                Access Key
                            </Col>
                            <Col sm={7}>
                                <FormControl
                                    name='access_key'
                                    type='text'
                                    required={true}/>
                            </Col>
                            <HelpBlock>{this.state.errorMsg}</HelpBlock>
                        </FormGroup>
                        <div className='button-footer-center'>
                            <Button
                                className='btn--red'
                                onClick={this.onDecline}>
                                {'Cancel'}
                            </Button>
                            <Button
                                className='btn--blue'
                                type='submit'>
                                Join Group
                            </Button>
                        </div>
                    </Form>
                </div>
                <Processing isProcessing={this.state.isProcessing} />
            </div>
        );
    }

}

export default connect()(JoinGroupModal);



// WEBPACK FOOTER //
// ./src/components/Group/JoinGroupModal.js